import React from 'react';
import { AlertCircle } from 'lucide-react';
import { isInvalidValue } from '@/utils/helpers';

interface FormattedFieldProps {
  label: string;
  value: React.ReactNode;
  rawValue?: unknown;
  showValidation?: boolean;
  className?: string;
}

/**
 * Component for displaying formatted field values with validation indicators
 * Shows a warning icon for missing or invalid data
 */
export const FormattedField: React.FC<FormattedFieldProps> = ({
  label,
  value,
  rawValue,
  showValidation = true,
  className = '',
}) => {
  const isInvalid =
    showValidation && isInvalidValue(rawValue !== undefined ? rawValue : value);

  return (
    <div className={`flex justify-between items-center ${className}`}>
      <span className="text-gray-600">{label}:</span>
      <span
        className={`font-medium flex items-center gap-1 ${
          isInvalid ? 'text-orange-600' : ''
        }`}
      >
        {value}
        {isInvalid && (
          <span title="Missing or invalid data">
            <AlertCircle className="w-4 h-4 text-orange-500" />
          </span>
        )}
      </span>
    </div>
  );
};
